var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.824738,
    y: -0.00195312,
    width: 33.0374,
    height: 33.0374,
    rx: 16.5187,
    fill: "url(#paint0_linear_1456_2437)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3653 22.3569C11.1031 22.4618 10.854 22.4389 10.618 22.2881C10.382 22.1374 10.264 21.9178 10.264 21.6293V18.0896L16.5568 16.5164L10.264 14.9432V11.4035C10.264 11.1151 10.382 10.8955 10.618 10.7447C10.854 10.5939 11.1031 10.571 11.3653 10.6759L23.479 15.7888C23.8067 15.933 23.9706 16.1755 23.9706 16.5164C23.9706 16.8573 23.8067 17.0998 23.479 17.244L11.3653 22.3569Z",
    fill: "#E8EAED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1456_2437",
    x1: 0.824738,
    y1: 16.5167,
    x2: 33.8621,
    y2: 16.5167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.531233,
    stopColor: "#B81D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92128"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3237a90682d82dc4cc31fd05c71628ec.svg";
export { ForwardRef as ReactComponent };